import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Breeze";
import campaign from "../assets/wetu/Optiven @ 24.png";

const Malindi7 = () => {
  const project_id = "PRJ00062";
  const title = "Malindi Breeze Phase 7";

  const mapConfig = {
    minZoom: 15,
    zoom: 16,
    bounds: [
      [40.66, -74],
      [40.64, -73.98],
    ],
    imageOverlays: [
      {
        imageUrl: campaign,
        imageBounds: [
          [40.69, -73.97],
          [40.68, -73.96],
        ],
      },
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={project_id}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/malindi-phase-7-gardens/"
      fillOfferLink="https://forms.gle/Sf2FuRmHsQfPiW2g9"
    />
  );
};

export default Malindi7;
